module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/h6ykYE/media/FC-9781035859900.jpg?1726850954160",
      "alt": "This image is the cover for the book The Last Crow"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Last Crow\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The idyll of English rural life is peeled back to reveal a world where the new money of hedge fund managers and oligarchs along with the old money of aristocracy is used to project power and protect centuries old traditions. They will go to any lengths to silence opponents and activists are equally determined to reveal the truth behind hunting and shooting. On the ground gamekeepers and hunt operatives follow their orders leaving them one mistake away from losing their homes and livelihoods. But many in the rural community are making differentchoices. Activist Raven Harley is far from alone in his struggle but he soon realises the mistake he made in leaving his long-term partner Chloe for influencer Becky. Now it’s Chloe who gathers the evidence that impels the police to investigate rather than protect the establishment. And as Raven faces increasing danger, can Chloe ever forgive him?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Bob Berzins\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Bob Berzins can usually be found on the Peak District moors near his home in Sheffield, rock climbing or fell running. Although many of these areas are within the National Park and have protected conservation status, the ravages of our biodiversity crisis and climate crisis are all too apparent, and Bob spends much of his time campaigning for wildlife and the environment. He’s written numerous blogs and a self-published novel, Snared.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0